import { useSchemaMutation } from '@frontend/react-query-helpers';
import { SchemaIO } from '@frontend/schema';
import { SchemaManualSmsScheduledV1Service, serviceName } from '../service';
import { MutationEndpointName, ServiceMutations } from '../types';

export type UseManualSmsScheduledV1MutationArgs<
  EndpointName extends MutationEndpointName,
  E = unknown,
  C = unknown,
  OtherOptions extends object = never,
  RequestOverride extends SchemaIO<ServiceMutations[EndpointName]>['input'] = SchemaIO<
    ServiceMutations[EndpointName]
  >['input']
> = Omit<
  Parameters<typeof useSchemaMutation<ServiceMutations, EndpointName, E, C, OtherOptions, RequestOverride>>[0],
  'service' | 'serviceName'
>;

export const useManualSmsScheduledV1Mutation = <
  EndpointName extends MutationEndpointName,
  E = unknown,
  C = unknown,
  OtherOptions extends object = never,
  RequestOverride extends SchemaIO<ServiceMutations[EndpointName]>['input'] = SchemaIO<
    ServiceMutations[EndpointName]
  >['input']
>(
  args: UseManualSmsScheduledV1MutationArgs<EndpointName, E, C, OtherOptions, RequestOverride>
) =>
  useSchemaMutation<ServiceMutations, EndpointName, E, C, OtherOptions, RequestOverride>({
    service: SchemaManualSmsScheduledV1Service,
    serviceName,
    ...args,
  });

export type UseManualSmsScheduledV1MutationEndpointArgs<
  EndpointName extends MutationEndpointName,
  E = unknown,
  C = unknown,
  OtherOptions extends object = never,
  RequestOverride extends SchemaIO<ServiceMutations[EndpointName]>['input'] = SchemaIO<
    ServiceMutations[EndpointName]
  >['input']
> = Omit<UseManualSmsScheduledV1MutationArgs<EndpointName, E, C, OtherOptions, RequestOverride>, 'endpointName'> & {
  optimisticUpdate?: boolean;
};
